import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useToast } from '../../context/ToastContext';

export default function ProgressReportsHome() {
  const { api } = useAuth();
  const toast = useToast();
  const [reports, setReports] = useState(null);
  const [adding, setAdding] = useState(false);
  const [form, setForm] = useState({ donor_name: '', title: '' });

  // toast خارج الاعتماديات — هويته تتغير مع كل toast فيعيد إطلاق الجلب بلا نهاية عند الفشل
  const load = useCallback(() => {
    api('/progress/reports').then(setReports).catch((e) => toast.error(e.message));
  }, [api]);
  useEffect(() => { load(); }, [load]);

  const submit = async () => {
    try {
      const body = { donor_name: form.donor_name };
      if (form.title) body.title = form.title;
      await api('/progress/reports', { method: 'POST', body: JSON.stringify(body) });
      toast.success('تم إنشاء التقرير');
      setForm({ donor_name: '', title: '' });
      setAdding(false);
      load();
    } catch (e) { toast.error(e.message); }
  };

  if (!reports) return <div className="loader">جاري التحميل...</div>;

  return (
    <div>
      <div className="card" style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, flexWrap: 'wrap' }}>
        <div>
          <div className="card-title">تقارير التقدّم الشهرية</div>
          <p style={{ color: 'var(--text-muted)', fontSize: 13, margin: '6px 0 0' }}>
            تقرير لكل جهة مانحة يجمع مشاريعها في مصفوفات حالة (بنود × مراحل)، يُنشر شهرياً برابط عام —
            مع خيار المتابعة اللحظية للمشاريع المرتبطة بالمنصة.
          </p>
        </div>
        <button className="btn btn-primary btn-sm" onClick={() => setAdding((v) => !v)}>＋ تقرير جديد</button>
      </div>

      {adding && (
        <div className="card" style={{ marginBottom: 16, background: 'var(--surface-alt)' }}>
          <div className="card-title" style={{ marginBottom: 10 }}>تقرير جديد</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 10 }}>
            <div>
              <label className="form-label" style={{ fontSize: 12 }}>اسم الجهة المانحة *</label>
              <input className="form-input" value={form.donor_name} onChange={(e) => setForm((f) => ({ ...f, donor_name: e.target.value }))} />
            </div>
            <div>
              <label className="form-label" style={{ fontSize: 12 }}>عنوان التقرير (اختياري)</label>
              <input className="form-input" placeholder="التقرير الشهري للمشاريع" value={form.title} onChange={(e) => setForm((f) => ({ ...f, title: e.target.value }))} />
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
            <button className="btn btn-primary btn-sm" onClick={submit} disabled={!form.donor_name}>حفظ</button>
            <button className="btn btn-outline btn-sm" onClick={() => setAdding(false)}>إلغاء</button>
          </div>
        </div>
      )}

      {reports.length === 0 ? (
        <div className="empty">لا توجد تقارير بعد — أنشئ أول تقرير من الزر أعلاه.</div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 12 }}>
          {reports.map((r) => (
            <Link key={r.id} to={`/progress-reports/${r.id}`} className="card" style={{ textDecoration: 'none' }}>
              <div style={{ fontWeight: 700, fontSize: 15, color: 'var(--text)' }}>{r.donor_name}</div>
              <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 6 }}>
                {r.projects_count ?? 0} مشروع · {r.periods_count ?? 0} شهر منشور
              </div>
              <div style={{ display: 'flex', gap: 6, marginTop: 8, flexWrap: 'wrap' }}>
                {r.public_enabled
                  ? <span className="badge" style={{ background: 'var(--c-success-soft)', color: 'var(--c-success)' }}>الرابط العام مفعّل</span>
                  : <span className="badge" style={{ background: 'var(--surface-alt)', color: 'var(--text-muted)' }}>غير منشور</span>}
                {r.live_enabled && <span className="badge" style={{ background: 'var(--c-blue-100)', color: 'var(--text-strong)' }}>متابعة لحظية</span>}
                {r.is_protected && <span className="badge" style={{ background: 'var(--c-gold-soft)', color: 'var(--c-gold-ink)' }}>🔒 بكلمة مرور</span>}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
